import type { WalkthroughEvent } from '@shared-types/frontend-scenario-definition';

export const participantViewWalkthrough: WalkthroughEvent = {
    key: 'participant-view-walkthrough',
    showAt: 'start',
    steps: [
        {
            id: '0',
            element: { selector: '[data-tour=dashboard]' },
            position: 'right',
            text: 'app.platformTour.dashboard',
        },
        {
            id: '1',
            element: { selector: '[data-tour=courses]' },
            text: 'app.platformTour.courses',
        },
        {
            id: '2',
            element: { selector: '[data-tour=progress-report]' },
            text: 'app.platformTour.progressReport',
        },
        {
            id: '3',
            element: { selector: '[data-tour=help]' },
            text: 'app.platformTour.help',
        },
        {
            id: '4',
            element: { selector: '[data-tour=profile-settings]' },
            text: 'app.platformTour.profileSettings',
        },
        {
            id: '5',
            element: { selector: '[data-tour=display-settings]' },
            text: 'app.platformTour.displaySettings',
        },
    ],
};

export default participantViewWalkthrough;
